import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import getAccountShipmentV2, {
  type V2ShipmentDetail,
} from '../getAccountShipmentV2';

export type PostAccountShipmentDevicesVariables = {
  accountId: number;
  shipmentId: number;
  payload: { device_ids: number[] };
};

/**
 * POST `/api/v2/accounts/{account}/shipments/{shipment}/devices` — assign devices on device-api draft.
 */
export default function usePostAccountShipmentDevices() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      shipmentId,
      payload,
    }: PostAccountShipmentDevicesVariables) => {
      const { api, baseURL } = getApi();
      const res = await api.post(
        `/api/v2/accounts/${accountId}/shipments/${shipmentId}/devices`,
        payload,
        { baseURL },
      );
      return (res.data?.data ?? res.data) as V2ShipmentDetail;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['account-shipments'] });
      queryClient.invalidateQueries({
        queryKey: getAccountShipmentV2.queryKey(
          variables.accountId,
          variables.shipmentId,
        ),
      });
    },
  });
}
